<div class="growth-stats-page">
  <header class="page-header">
    <h1>Croissance</h1>
    <p class="subtitle">Inscriptions, rétention et activité des utilisateurs</p>
  </header>

  <app-period-filter (periodChange)="onPeriodChange($event)"></app-period-filter>

  @if (isLoading) {
  <div class="loading">
    <div class="spinner"></div>
    <p>Chargement...</p>
  </div>
  } @else if (error) {
  <div class="error-message">
    <p>{{ error }}</p>
    <button type="button" (click)="loadStats()">Réessayer</button>
  </div>
  } @else if (stats) {

  <!-- KPI Cards -->
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon new-users">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="8.5" cy="7" r="4" />
          <line x1="20" y1="8" x2="20" y2="14" />
          <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalNewUsers }}</span>
        <span class="stat-label">Nouveaux inscrits</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon dau">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.dau }}</span>
        <span class="stat-label">DAU (aujourd'hui)</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon wau">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.wau }}</span>
        <span class="stat-label">WAU (7 jours)</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon mau">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.mau }}</span>
        <span class="stat-label">MAU (30 jours)</span>
      </div>
    </div>
  </div>

  <!-- Registration Chart -->
  <section class="chart-section">
    <h2>Inscriptions par jour</h2>
    <div class="chart-container">
      @if (stats.newUsersPerDay && stats.newUsersPerDay.length > 0) {
      <div class="chart">
        @for (point of stats.newUsersPerDay; track point.date) {
        <div class="chart-bar-container">
          <div
            class="chart-bar"
            [style.height]="getBarHeight(point.value, getMaxValue(stats.newUsersPerDay))"
          >
            <span class="bar-value">{{ point.value }}</span>
          </div>
          <span class="bar-label">{{ formatBarLabel(point.date) }}</span>
        </div>
        }
      </div>
      } @else {
      <p class="no-data">Aucune donnée pour cette période</p>
      }
    </div>
  </section>

  <!-- Retention & Churn -->
  <section class="metrics-section">
    <h2>Rétention & Churn</h2>
    <div class="metrics-grid">
      <div class="metric-card">
        <div class="metric-header">
          <span class="metric-title">Rétention J+1</span>
          <span class="metric-badge retention">{{ stats.retentionD1 }}%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill retention" [style.width.%]="stats.retentionD1"></div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-header">
          <span class="metric-title">Rétention J+7</span>
          <span class="metric-badge retention">{{ stats.retentionD7 }}%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill retention" [style.width.%]="stats.retentionD7"></div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-header">
          <span class="metric-title">Rétention J+30</span>
          <span class="metric-badge retention">{{ stats.retentionD30 }}%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill retention" [style.width.%]="stats.retentionD30"></div>
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-header">
          <span class="metric-title">Churn (30j)</span>
          <span class="metric-badge churn">{{ stats.churnedUsers }} ({{ stats.churnRate }}%)</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill churn" [style.width.%]="stats.churnRate"></div>
        </div>
      </div>
    </div>
  </section>

  }
</div>
